import type {Study, StudyStatus} from '@cp/model';
import {updateDoc} from 'firebase/firestore';
import {getStudyDocRef} from './getStudyDocRef';
import getStudyDocValidated from './getStudyDocValidated';

export default async function updateStudyStatusOnlyDoc(
  moduleId: string,
  topic: string,
  status: StudyStatus,
): Promise<Study> {
  const ref = getStudyDocRef(moduleId, topic);
  await updateDoc(ref, {status});
  return getStudyDocValidated(moduleId, topic);
}
